import React from 'react'
import { SEO } from '../../../../components/Seo/seo'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { useParams } from 'react-router-dom'
import NoMatch from '../../../NoMatch'
import { downPayment } from '../../../../utils/pages-meta'
import { FormattedMessage, useIntl } from 'react-intl'
import InActiveUserContent from '../../../../components/InActiveUserContent'
import { SearchLoader } from '../../../../components/Loader/SearchLoader'
import CompanyDownPaymentContent from '../../../../components/Workspace/CompanyPage/CompaniesDownPayment'
import { Container } from '@material-ui/core'
import { useStyles } from '../Styles'

const DownPayment = () => {
  let { id } = useParams()
  const intl = useIntl()
  const classes = useStyles()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'PageTitle.DownPayment' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax-Workspace' })}
               image={downPayment.image}
               description={intl.formatMessage({ id: 'PageTitle.DownPayment' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, isUserActive, userData, checkCompanyData }) => (
              <>
                <Container maxWidth="lg" className={classes.TitleContainer}>
                  <h1><FormattedMessage id='PageTitle.DownPayment'/></h1>
                </Container>
                {!!userDataLoading && <SearchLoader loading={true}/>}
                {(!!Object.keys(userData).length && !!isUserActive) ?
                  <CompanyDownPaymentContent checkCompanyData={checkCompanyData} cid={id}/>
                  : (!userDataLoading && <InActiveUserContent/>)
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <NoMatch/>
      }
    </>
  )
}

export default DownPayment
